<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';

// Sits inside a `relative` input wrapper, over the input's right padding.
withDefaults(defineProps<{ label?: string }>(), { label: 'Clear' });
</script>

<template>
  <button
    type="button"
    :aria-label="label"
    class="absolute top-1/2 right-2 -translate-y-1/2 rounded p-1 text-gray-400 hover:text-gray-600"
  >
    <XMarkIcon class="h-4 w-4" />
  </button>
</template>
